import { render, staticRenderFns } from "./sldeverfyxg.vue?vue&type=template&id=68dbc2e7&scoped=true"
import script from "./sldeverfyxg.vue?vue&type=script&lang=js"
export * from "./sldeverfyxg.vue?vue&type=script&lang=js"
import style0 from "./sldeverfyxg.vue?vue&type=style&index=0&id=68dbc2e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dbc2e7",
  null
  
)

export default component.exports